export default __webpack_public_path__ + "mb-more6494db.svg";